import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="w-full bg-slate-800 py-20 px-4" data-id="element-129">
      <motion.div className="max-w-4xl mx-auto" initial={{
      opacity: 0,
      y: 50
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-130">
        <p className="text-xl md:text-2xl leading-relaxed text-gray-200 text-center" data-id="element-131">
          Ves las noticias sobre{' '}
          <span className="text-teal-400 font-semibold" data-id="element-132">
            "Inteligencia Artificial"
          </span>{' '}
          y, en el fondo,{' '}
          <span className="text-red-400 font-semibold" data-id="element-133">te aterra</span>. No
          porque la IA te reemplace, sino porque{' '}
          <span className="text-gold-400 font-semibold" data-id="element-134">
            otros la están usando para saltar la fila
          </span>{' '}
          mientras tú sigues esperando tu turno.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed text-gray-200 text-center mt-8" data-id="element-135">
          El problema no es tu falta de capacidad. El problema es que te han
          vendido que para ganar dinero con IA necesitas ser{' '}
          <span className="line-through text-gray-500" data-id="element-136">
            un ingeniero de la NASA
          </span>{' '}
          o pagar{' '}
          <span className="line-through text-gray-500" data-id="element-137">
            cursos de $1,000 USD que duran meses
          </span>
          .
        </p>

        <motion.p className="text-3xl md:text-4xl font-heading font-bold text-gold-400 text-center mt-8" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-138">
          Mentira.
        </motion.p>
      </motion.div>
    </section>;
}